import React from 'react'
import styled from 'styled-components'

const Video = ({
  webm,
  mp4,
  poster,
  className,
  modal,
  muted,
  controls,
  shouldAutoplay = true,
}) => {
  return (
    <StyledVideo className={className}>
      <VideoPlayer
        autoPlay={shouldAutoplay}
        disableRemotePlayback
        loop
        playsInline
        muted={muted ?? !modal}
        controls={controls ?? modal}
        poster={poster?.src}
      >
        {/**
         * The order of these are important,
         * as the browser is going to load to first supported source
         */}
        <source src={webm} type='video/webm' />
        <source src={mp4} type='video/mp4' />
      </VideoPlayer>
    </StyledVideo>
  )
}

const StyledVideo = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    overflow: hidden;
  }
`

const VideoPlayer = styled.video`
  object-fit: cover;
  height: 100%;
  width: 100%;

  &:hover::-webkit-media-controls {
    opacity: 1;
  }

  &::-webkit-media-controls {
    opacity: 0;
    transition: opacity 0.3s;
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    width: auto;
  }
`

export default Video
